import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  login,
  loginAdmin,
  socialLogin,
} from "../../redux/actions/userActions";
import styles from "./SignIn.module.css";
import { Alert } from "reactstrap";
// , googleAuthProvider
import { firebase } from "../../firebase";
import {
  FirebaseAuthProvider,
  FirebaseAuthConsumer,
} from "@react-firebase/auth";

const SignIn = ({ history }) => {
  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);
  const { loading, userInfo, error } = userLogin;

  const auth = useSelector((state) => state.adminLoginReducer);
  const { loadingAdmin, adminInfo, errorAdmin } = auth;

  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [admin, setAdmin] = useState(false);
  const [data, setData] = useState("");

  // useEffect(() => {
  //   if (userInfo && adminInfo) {
  //     history.push("/");
  //   }
  // }, [history, userInfo, adminInfo]);

  // const dat = JSON.parse(data);
  console.log(data && data.displayName);

  // const nam = data?.displayName;
  // const emai = data?.email;
  // const ph = "12345678";
  // const country = "Italy";
  useEffect(() => {
    dispatch(
      socialLogin(data?.displayName, data?.email, "12345678", "Italy", history)
    );
  }, [history, data]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(login(phone, history));
  };
  const handleAdminSubmit = (e) => {
    e.preventDefault();
    dispatch(loginAdmin(email, password, history));
  };

  const handleAdmin = () => {
    setAdmin(!admin);
  };
  return (
    <div className={styles.container}>
      <header>
        <Link to="/">
          <h1>Uora</h1>
        </Link>
      </header>
      <main>
        <div className={styles.fieldsContainer}>
          <p>Sign In</p>
          <div className={styles.errorField}>
            {error ||
              (errorAdmin && (
                <Alert color="danger">Something went wrong !</Alert>
              ))}
          </div>

          {!admin ? (
            <div className={styles.field}>
              <label>Phone Number</label>
              <input
                type="text"
                name="country"
                placeholder="Enter phone number"
                value={phone}
                autoComplete="off"
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>
          ) : (
            <>
              <div className={styles.field}>
                <label>Email Address</label>
                <input
                  type="email"
                  name="email"
                  placeholder="Enter email address"
                  value={email}
                  autoComplete="off"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className={styles.field}>
                <label>Password</label>
                <input
                  type="password"
                  name="password"
                  placeholder="Enter password"
                  value={password}
                  autoComplete="off"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
            </>
          )}

          <button onClick={admin ? handleAdminSubmit : handleSubmit}>
            {loading || loadingAdmin ? (
              <span>Loading...</span>
            ) : (
              <span>Continue</span>
            )}
          </button>
          <small>We'll send OTP for verification</small>
          <div className={styles.adminButton}>
            <button onClick={handleAdmin}>
              SignIn as a {admin ? <span>user</span> : <span>admin</span>}
            </button>
          </div>
          <googleAuthProvider />
          <Link to="/register">
            <p>Register</p>
          </Link>
          <p>Or continue with</p>
        </div>
        <div className={styles.btnsContainer}>
          <FirebaseAuthProvider {...firebase} firebase={firebase}>
            <button
              onClick={() => {
                const faceBookAuthProvider = new firebase.auth.FacebookAuthProvider();
                firebase.auth().signInWithPopup(faceBookAuthProvider);
              }}
            >
              Facebook
            </button>
            <button
              onClick={() => {
                const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
                firebase.auth().signInWithPopup(googleAuthProvider);
              }}
            >
              Google
            </button>
            {/* <button
              onClick={() => {
                firebase.auth().signOut();
              }}
            >
              Sign Out
            </button> */}
            <FirebaseAuthConsumer>
              {({ user }) => {
                return <pre style={{ display: "none" }}>{setData(user)}</pre>;
              }}
            </FirebaseAuthConsumer>
          </FirebaseAuthProvider>
        </div>
      </main>
    </div>
  );
};

export default SignIn;

{
  /* <FirebaseAuthProvider {...firebase} firebase={firebase}>
        <div>
          <button
            onClick={() => {
              const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
              firebase.auth().signInWithPopup(googleAuthProvider);
            }}
          >
            Sign In with Google
          </button>
          <button
            onClick={() => {
              firebase.auth().signOut();
            }}
          >
            Sign Out
          </button>
          <FirebaseAuthConsumer>
            {({ user }) => {
              return (
                <pre style={{ height: 300, overflow: "auto" }}>
                  {JSON.stringify({  user }, null, 2)}
                </pre>
              );
            }}
          </FirebaseAuthConsumer>
        </div>
      </FirebaseAuthProvider> */
}
